import React from "react";
import "../assets/css/About.css";
import pageheader from "../assets/images/page-header.jpg";
import { useNavigate } from "react-router-dom";
import aboutus from "./../assets/images/about-us.png";
import { useDocumentMetaData } from "../common/components/useDocumentMetaData";

function About() {

  useDocumentMetaData({
    title: "About MyBuilderID - Build Your Digital Identity",
    description: "Learn how MyBuilderID helps builders create strong online identities, showcase work, and connect with clients.",
    keywords: "about MyBuilderID, builder digital identity, portfolio platform",
    canonical: "https://mybuilderid.com/about",
    robots: "index, follow",
    author: "MyBuilderID Team",
    ogTitle: "About MyBuilderID",
    ogDescription: "We help builders showcase their projects, build trust, and connect with clients.",
    ogImage: "https://mybuilderid.com/static/media/logo01.a7fc7fdc78443fa49049.png",
    ogUrl: "https://mybuilderid.com/about",
    twitterCard: "summary_large_image",
    twitterTitle: "About MyBuilderID - Digital Identity for Builders",
    twitterDescription: "Helping builders build trust, showcase projects, and connect online.",
    twitterImage: "https://mybuilderid.com/static/media/logo01.a7fc7fdc78443fa49049.png"
  });

  const navigate = useNavigate();

  return (
    <>
      <section
        className="hero-area bg_img about"
        style={{
          backgroundImage: `url(${pageheader})`,
        }}>
        <div className="container">
          <h1 className="title m-0">About</h1>
        </div>
      </section>
      <div className="breadcrumb-section">
        <div className="container">
          <ul className="breadcrumb">
            <li style={{ cursor: "pointer" }} onClick={() => navigate("/")}> Home</li>
            <div style={{ margin: "0px 10px 0px 10px" }}> - </div>
            <li>About</li>
          </ul>
        </div>
      </div>

      <section className="faq-section padding-top padding-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="faq-area">
                <div className="container">
                  <div className="container-1 about-container" style={{ display: "flex" }}>
                    <ul className="faq-content" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                      <li>
                        BuildID is a tool for tradespeople and others working in the construction industry that take pride in building the structures that shape our world. We want to create a construction community that empowers and rewards all members.
                      </li>
                      <li>
                        BuildID is an easy way to keep track of your hard work on each job site as well as keep you in touch with people you meet along the way!
                      </li>
                      <li>
                        BuildID is a free mobile app that is available on both Android and iPhone platforms.
                      </li>
                      <li>
                        From auto-generated resumes, to keeping track of your safety tickets, and so much more. BuildID is an app that you will want to use.
                      </li>
                      <li>
                        If you are involved with the construction industry or even just interested in what is being built around you, this app is for you.
                      </li>
                    </ul>
                    <img src={aboutus} alt="BuildId - mybuilderid.com" style={{ borderRadius: "8px", maxHeight: "50vh", margin: "0px 0px 0px 36px", boxShadow: "0px 4px 25px gray" }} />


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
